export const iconFontAwesomeFilmVideoSquareRss = (
	<i className="fa-solid fa-square-rss"></i>
);
